import { styled } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';


export const useStyles = makeStyles(theme => ({
  root: ({themePalets}) => ({
    closeIcon: {
        fontSize: '20px',
        color: `${themePalets.palette.tertiary.closeIconColor} !important`,
    }
  }),
  closeIcon: () => ({
    cursor: 'pointer'
  }),
  infoMessageClass: () => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0 !important',
  }),
  rightButtonStyle: props => ({
    opacity: props.rightActionDisabled ? '0.5' : '1',
  }),
  leftButtonStyle: props => ({
    opacity: props.leftActionDisabled ? '0.5' : '1',
  }),
  customContainer: props => ({
    display: 'flex',
    flexDirection: 'column',
    background: `${props.themePalets.palette.primary.cards}`,
    width: 'auto'
  })
}), { name: 'CustomPopup' })

export const MessageLayout = styled('div')(({ isWeb }) => ({
    margin: '24px 0',
    textAlign: 'center',
    marginTop: isWeb ? '30px' : '24px',
    flex: 1, 
    overflowY: 'auto', 
    display: 'flex', 
    alignItems: 'center',
    justifyContent: 'center', 
    flexDirection: 'column',
    overflowX: 'hidden',
}));

export const MessageLayoutNew = styled('div')({
  margin: '16px',
  padding: "0px 16px 8px",
  textAlign: 'center',
});

export const CloseIconFrame = styled('div')(({ theme, isWeb }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: 'solid 1px',
    marginRight: isWeb && '10px',
    minHeight: '55px',
    flexWrap: 'wrap',
    position: "unset !important",
    borderColor: `${theme.palette.tertiary.popupHeadingBorder}!important`,
    borderStyle: 'none none groove none',
    background: 'transparent !important',
}));
export const InformationFrame = styled('div')(({ icon }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: icon && "24px",
}));
export const PopUpTitle = styled('div')(({ theme, isWeb }) => ({
    padding: '0 16px',
    fontSize: isWeb ? '20px' :'16px',
    fontFamily: 'Visuelt',
    fontWeight: '500',
    lineHeight: '18px',
    background: "none !important",
    width: '100% !important',
    color: `${theme.palette.tertiary.labelText} !important`,
}));
export const InfoMsg = styled('div')(({ theme, fontSize, isWeb }) => ({
    padding: '0 16px',
    fontSize: isWeb ? '15px' : (fontSize || '12px'),
    fontFamily: 'Visuelt',
    fontWeight: '400',
    lineHeight: '18px',
    color: `${theme.palette.tertiary.titleBox} !important`,
}));


export const ActionItem = styled('div')(({ theme, isWeb }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  textAlign: 'center',
  borderTop: "none",
  padding: "0px 16px 10px 16px",
  flexDirection: "row",
  marginTop : isWeb && '20px',

  '& > div': {
    flex: 1,
    minWidth: '0',
    color: '#01B5DE',
    fontWeight: '400',
    fontFamily: 'Visuelt',
    padding: isWeb ? '16px 20px' : '12px 16px',
    backgroundColor:"#FFFFFF",
    fontSize: isWeb && '20px',
    borderRadius: '10px',
    border: 'solid 1px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    wordBreak: "break-word"
  },

  '& > div:nth-child(1)': {
    backgroundColor: "transparent !important",
    color: '#01B5DE',
    '&:nth-last-child(2)': {
      marginRight: '10px',
    }
  },

  '& > div:nth-child(2)': {
    fontWeight: '500',
    backgroundColor: `${theme.palette.tertiary.checkBoxFill} !important`,
    color: "#fff"
  },

  '& > div:only-child': {
    flex: '1',
    color: "#fff !important",
    backgroundColor: `${theme.palette.tertiary.checkBoxFill} !important`,
    border: 'none'
  },
  '& > div:last-child': {
    marginRight: '0',
    border: 'none',
    color: "#fff !important",
    background: `${theme.palette.tertiary.checkBoxFill} !important`,
    borderRadius: '10px'
  },
  '& > div > span': {
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit'
  },
}));


